<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  .layout-content {
    height: 100%;
    overflow: hidden;
  }
  .layout-header {
    background: #1d9dda;
    .layout-header__spacing {
      width: 1px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
    }
    .layout-header__mag {
      width: 10px;
      height: 30px;
      overflow: hidden;
    }
  }
  .layout-aside {
    width: 260px !important;
    .layout-aside__menu {
      height: 100%;
    }
  }

  .layout-main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <el-container class="layout">
    <el-header class="layout-header flex-row-between">
      <img src="~@/assets/images/logo.png" />
      <div class="layout-header__right">
        <el-dropdown @command="dropdownHandler">
          <div class="el-dropdown-link flex-row-start pointer">
            <div class="layout-header__avatar flex-row-center MR-10">
              <img src="~@/assets/images/index06.png" />
            </div>
            <div class="text-white text-16">{{userInfo.fullName}}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown @command="dropdownPositionList" >
          <div class="el-dropdown-link flex-row-start pointer ML-15">
            <div class="layout-header__spacing flex-row-center"></div>
            <div class="text-white text-16">{{showPosition.titleName+`(${showPosition.deptName})`}}</div>
          </div>
          <el-dropdown-menu slot="dropdown" :tabindex="tindex">
            <div class="dropdownBox" style="max-height:500px;overflow:auto">
              <el-dropdown-item v-for="(item,index) in positionList" :command="item" :key="index">{{item.titleName+`(${item.deptName})`}}</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container class="layout-content">
      <el-aside class="layout-aside">
        <el-menu class="layout-aside__menu" :default-active="decodeURIComponent($route.fullPath)" router>
          <MainMenu v-for="(item,index) in menuList" :key="index" :menuItem="item" :level="1" />
        </el-menu>
      </el-aside>
      <el-main>
        <transition name="fade-transform" mode="out-in">
          <router-view class="layout-main" :key="key"></router-view>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import config from "@/config/index";
import MainMenu from '@/components/MainMenu.vue'
export default {
  data() {
    return {
      // 用户信息
      userInfo: {},
      positionList:[],
      showPosition:{},
      authorization:"",
      menuList:[],
      tindex:0
    };
  },
  computed:{
    key(){
      return this.$route.fullPath + Math.random();
    }
  },
  created() {
    this.userInfo = this.$store.state.userInfo || {}
    this.authorization = this.userInfo.jti;
    if(!this.authorization) return this.$router.replace("/login");
    this.getUserInfo();
    this.setUserMenus();
  },
  methods: {
    decodeURIComponent(url){
      return decodeURIComponent(url)
    },
    /**
     * 获取用户岗位信息
     */
    getUserInfo() {
      this.$ajax(
        config.EXTERNAL_API+ "/user/getUserPositionList",
        {},
        {
          load:false,
          method: "get"
        }
      ).then(data => {
        this.positionList = data.data.positionList;
        if(this.positionList.length){
          this.showPosition = this.positionList[0] || {};
          let deptId = this.userInfo.deptId;
          let titleId = this.userInfo.titleId;
          let showPosition = this.positionList.filter(item=>{
            if("" + item.deptId + item.titleId === "" + deptId + titleId){
              return item
            }
          })
          this.showPosition = showPosition[0] || this.positionList[0] || {};
        }
      });

    },
    /**
     * 触发下拉菜单事件 -> 岗位
     */
    dropdownPositionList(command) {
      if(this.showPosition.deptId+""+this.showPosition.titleId === command.deptId+""+command.titleId) return;
      this.showPosition = command;
      this.menuList = [];
      this.$router.replace("/");
      this.$ajax(
        config.EXTERNAL_API + `/user/changePosition/${command.deptId}/${command.titleId}`,
        {},
        {
          method:"get",
          load:true
        },
      ).then(() => {
        this.getUserMenus();
        this.getCurrentUserInfo();
      });
    },

     /**
     * 触发下拉菜单事件
     */
    dropdownHandler(command) {
      switch (command) {
        case "user":
          break;
        case "logout":
          this.logout();
          break;
      }
    },

     /**
     * 设置用户菜单
     */
    setUserMenus(){
      let menus = this.$store.state.menuList;
      let menuList = [];
      if(menus[0]){
        menuList = menus[0].treeNodes || []
      }
      this.menuList = menuList;
      this.redirectRouter();
    },

    /**
     * 获取用户菜单
     */
    getUserMenus(load = true){
      this.$ajax(
        config.EXTERNAL_API+ `/user/getUserMenus/DATA_CENTER`,
        {},
        {
          load,
          method:"get"
        },
      ).then(data => {
        // 测试使用
        // data.data.menus[0].treeNodes[1].treeNodes[0].channel.name='核心数据统计'
        // data.data.menus[0].treeNodes[1].treeNodes[0].channel.url='/model/core-data-statistic'
        this.$store.commit('setMenuList',data.data.menus)
        this.setUserMenus();
      });
    },

    /**
     * 菜单重组成列表
     */
    reformMenuList(menus){
      let menuList = [];
      function getChildMenus(menus){
        menus.forEach(item => {
          if(item.treeNodes.length){
            getChildMenus(item.treeNodes);
          }else if(item.channel.url){
            menuList.push(item)
          }
        });
      }
      getChildMenus(menus);
      return menuList
    },

     /**
     * 获取当前用户信息
     */
    getCurrentUserInfo(){
      this.$ajax(
        config.EXTERNAL_API+ `/user/getCurrentUserInfo`,
        {},
        {
          load:false,
          method:"get",
        },
      ).then(data => {
        let userInfo = data.data
        userInfo.jti = this.userInfo.jti
        this.$store.commit('setUserInfo',userInfo)
      });
    },
    
     /**
     * 找到第一个菜单(路由)
     */
    getFirstMenu(menuObj){
      if(!menuObj.treeNodes.length){
        return menuObj
      }else{
        return this.getFirstMenu(menuObj.treeNodes[0])
      }
    },

    /**
     * 退出登陆
     */
    logout() {
      this.$ajax(
        config.EXTERNAL_API + "/login/loginOut", 
        {
        },
        {
          method:"get",
          headers:{
            "Authorization":this.authorization,
          }
        }
      ).then(() => {
        this.$message.success("退出登陆成功");
        this.$store.commit('setUserInfo',{})
        this.$store.commit('setMenuList',[])
        this.$router.replace({
          path: "/login"
        });
      });
    },
    /**
     * 重定向地址
     */
    redirectRouter(){
      let menus = this.$store.state.menuList;
      let menuList = [];
      if(menus[0]){
        menuList = menus[0].treeNodes || []
      }

      // 无菜单权限 -->菜单列表为空
      if(!menus.length || !menuList.length){
        if(this.$route.path !== "/limits-of-authority"){
          this.$router.replace("/limits-of-authority")
        }
        return
      }

      // 有菜单列表，处在'/'和'/limits-of-authority' 路由下
      if(this.$route.path === "/" || this.$route.path === "/limits-of-authority"){
          let defaultRoute = this.getFirstMenu(menuList[0])
          this.$router.replace(defaultRoute.channel.url)
          return
      }

      // 有菜单列表，路由不在菜单里面 --> 用户当前路由权限（用户手动输入路由地址）
      let newMenuList = this.reformMenuList(menuList || [])
      let hasMenu = newMenuList.some(item=>{
        let path = item.channel.url.replace(/(\s*$)/g, "");
        let reg = new RegExp(path.replace(/\//g,"\\/").replace(/\?/g,"\\?")+"[\\/]?$",'i');
        return reg.test(decodeURIComponent(this.$route.fullPath))
      })
      if(!hasMenu){
        let defaultRoute = this.getFirstMenu(menuList[0])
        this.$router.replace(defaultRoute.channel.url)
      }
    }
  },
  watch:{
    $route(){
      this.redirectRouter();
    }
  },
  components: {
    MainMenu
  }
};
</script>
